import * as React from 'react';
import {useRoute} from 'react-router5';
import UserStore from 'stores/UserStore';

/**
 * The logout page.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Logout(): React.ReactElement {
  const {router} = useRoute();

  React.useEffect(() => {
    UserStore.logout();
    router.navigate('landing');
  }, []);

  return (
    <p>Пожалуйста подождите...</p>
  );
}
